// Derived defaults for small finance forms (audit rows F-108 and F-129). Dates, labels and identifiers only:
// no monetary amount, bank detail, payee or approver is ever derived here.

/** F-108: an internal reserve-fund code derived from its name, for example "Lift replacement" becomes "LIFT-REPLACEMENT". */
export function reserveFundCodeFromName(name:string){
 return name.normalize('NFKD').replace(/[^\p{L}\p{N}]+/gu,'-').replace(/^-+|-+$/g,'').toUpperCase().slice(0,40);
}

const isoDate=/^(\d{4})-(\d{2})-(\d{2})$/;
/** F-129: the day before the same date twelve months later, as an ISO date (1 Jan 2027 gives 31 Dec 2027). */
export function periodEndFromStart(startsOn:string){
 const m=isoDate.exec(startsOn);if(!m)return undefined;
 const y=Number(m[1]),mo=Number(m[2]),d=Number(m[3]);
 const start=new Date(Date.UTC(y,mo-1,d));if(start.getUTCFullYear()!==y||start.getUTCMonth()!==mo-1||start.getUTCDate()!==d)return undefined;
 const end=new Date(Date.UTC(y+1,mo-1,d));
 if(end.getUTCMonth()!==(mo-1+12)%12)end.setUTCDate(0);// 29 February start: use the last day of February
 end.setUTCDate(end.getUTCDate()-1);
 return end.toISOString().slice(0,10);
}

/** F-129: "2027 service-charge year", or "2027/28 service-charge year" when the year does not end in the same calendar year. */
export function periodLabelFromDates(startsOn:string,endsOn:string){
 const a=isoDate.exec(startsOn),b=isoDate.exec(endsOn);if(!a||!b)return undefined;
 return a[1]===b[1]?`${a[1]} service-charge year`:`${a[1]}/${String(b[1]).slice(2)} service-charge year`;
}
